import { Helmet } from "react-helmet-async"
import { RoomTypesList } from "./../../../RoomTypes"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"

export default function RoomTypes() {
	return (
		<>
			<Helmet>
				<title>Room Types</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.UPLOAD_BULK_HOTELS}>
				<RoomTypesList />
			</ForbidUnlessAuthorized>
		</>
	)
}
